import React from "react";

const Category = () => {
  return (
    <div>
      <div classname="card" >
        <h3 classname="card-title">Categories</h3>
     
        <img
          src="https://watchandlearn.scholastic.com/content/dam/classroom-magazines/watchandlearn/videos/animals-and-plants/plants/what-are-plants-/What-Are-Plants.jpg"
        //   classname="card-img-top"
        style={{width: "5vw" }}
          alt="..."
        />
      </div>

        <div classname="card-body">
          <p classname="card-text">Category Title</p>
        </div>
    </div>
  );
};

export default Category;
